import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, toastApiRef } from '@backstage/frontend-plugin-api';
import { calendarApiRef } from '../api/ref';
import { QUERY_KEYS } from './queryKeys';

export const useJoinEvent = () => {
  const calendarClient = useApi(calendarApiRef);
  const toastApi = useApi(toastApiRef);
  const queryClient = useQueryClient();

  const { mutate: joinEventMutation, isPending: isJoining } = useMutation({
    mutationFn: async (eventId: string) => {
      return await calendarClient.joinEvent(eventId);
    },
    retry: false,
    onSuccess: async () => {
      toastApi.post({
        title: 'An invitation has been sent to your mailbox.',
        status: 'success',
        timeout: 5000,
      });
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: QUERY_KEYS.allEvents() }); // will invalidate both list and details
    },
    onError: (err: Error) => {
      toastApi.post({
        title: 'Failed to join event',
        description: err.message || 'Unknown error',
        status: 'danger',
        timeout: 5000,
      });
    },
  });

  const joinEvent = (eventId: string) => {
    joinEventMutation(eventId);
  };

  return { joinEvent, isJoining };
};
